import { Router, RouterLink } from '@angular/router';
import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';

@Component({
  selector: 'app-login-page',
  standalone: true,
  imports: [
    RouterLink,
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatButtonModule,
    MatIconModule
  ],
  templateUrl: './login-page.component.html',
  styleUrl: './login-page.component.scss'
})
export class LoginPageComponent {
  loginForm: FormGroup;
  isSubmitting = false;
  showPassword = false;

  constructor(
    private readonly fb: FormBuilder,
    private readonly router: Router
  ) {
    this.loginForm = this.fb.group({
      domain: [
        '',
        [
          Validators.required,
          Validators.minLength(3),
          Validators.pattern(/^[a-z0-9]([a-z0-9-]{0,61}[a-z0-9])?$/i)
        ]
      ],
      username: ['', [Validators.required, Validators.minLength(2)]],
      password: ['', [Validators.required, Validators.minLength(6)]]
    });
  }

  onSubmit() {
    if (this.loginForm.valid) {
      this.isSubmitting = true;
      
      // Simulate login process
      setTimeout(() => {
        this.isSubmitting = false;
        // TODO: Implement actual login logic
        console.log('Login attempt:', this.loginForm.value);
        // On successful login, redirect to dashboard or home
        // this.router.navigate(['/dashboard']);
      }, 2000);
    } else {
      this.markFormGroupTouched();
    }
  }

  togglePasswordVisibility() {
    this.showPassword = !this.showPassword;
  }

  private markFormGroupTouched() {
    Object.keys(this.loginForm.controls).forEach(key => {
      const control = this.loginForm.get(key);
      control?.markAsTouched();
    });
  }

  getErrorMessage(controlName: string): string {
    const control = this.loginForm.get(controlName);
    if (control?.hasError('required')) {
      return 'This field is required';
    }
    if (control?.hasError('minlength')) {
      const requiredLength = control.getError('minlength').requiredLength;
      return `Minimum length is ${requiredLength} characters`;
    }
    if (control?.hasError('pattern')) {
      return 'Use letters, numbers, and hyphens only';
    }
    return '';
  }

  getPasswordType(): string {
    return this.showPassword ? 'text' : 'password';
  }

  goToForgotPassword(event: Event): void {
    event.preventDefault();
    const domainControl = this.loginForm.get('domain');
    const domain = (domainControl?.value ?? '').toString().trim().toLowerCase();
    if (!domain || domainControl?.invalid) {
      domainControl?.markAsTouched();
      return;
    }
    const host = this.resolveTenantParentHost(this.currentHostname());
    this.assignLocation(`https://${domain}.${host}/auth/forgot-password`);
  }

  /** Exact host / suffix match — avoids CodeQL incomplete substring sanitization. */
  resolveTenantParentHost(hostname: string): string {
    const host = hostname.trim().toLowerCase();
    if (
      host === 'localhost' ||
      host === 'dev.membertrace.com' ||
      host.endsWith('.dev.membertrace.com')
    ) {
      return 'dev.membertrace.com';
    }
    return 'membertrace.com';
  }

  /** Isolated for unit tests (location is not redefine-friendly in Chromium). */
  currentHostname(): string {
    return globalThis.location.hostname;
  }

  assignLocation(url: string): void {
    globalThis.location.assign(url);
  }

}
